import { render } from "./IconArrow.vue?vue&type=template&id=2089c156"
const script = {}

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconArrow.vue"]])

export default __exports__